<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <g clip-path="url(#clip0_258_5380)">
        <path d="M13.08 10C13.2 11.78 13.5 13.52 13.98 15.18L11.58 17.58C10.76 15.18 10.24 12.64 10.06 10H13.08ZM32.8 34.04C34.5 34.52 36.24 34.82 38 34.94V37.92C35.36 37.74 32.82 37.22 30.4 36.42L32.8 34.04ZM15 6H8C6.9 6 6 6.9 6 8C6 26.78 21.22 42 40 42C41.1 42 42 41.1 42 40V33.02C42 31.92 41.1 31.02 40 31.02C37.52 31.02 35.1 30.62 32.86 29.88C32.66 29.8 32.44 29.78 32.24 29.78C31.72 29.78 31.22 29.98 30.82 30.36L26.42 34.76C20.76 31.86 16.12 27.24 13.24 21.58L17.64 17.18C18.2 16.62 18.36 15.84 18.14 15.14C17.4 12.9 17 10.5 17 8C17 6.9 16.1 6 15 6Z" fill="white"/>
        </g>
        <defs>
        <clipPath id="clip0_258_5380">
        <rect width="48" height="48" fill="white"/>
        </clipPath>
        </defs>
        </svg>
</template>

<script>
export default {
   name: 'Phone',
}

</script>